<template>
  <v-card class="mb-1" outlined>
    <v-row no-gutters align="center">
      <v-col cols="1">
        <v-row justify="center">
          <template v-if="item.status === 'OPEN'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-hover>
                  <v-icon
                    v-on="on"
                    slot-scope="{ hover }"
                    v-on:click="toggleItemStatus(item, index)"
                    :color="`${hover ? 'primary' : 'gray'}`"
                    >check_circle_outline
                  </v-icon>
                </v-hover>
              </template>
              <span>Maßnahme als erledigt markieren</span>
            </v-tooltip>
          </template>
          <template v-if="item.status === 'COMPLETED'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-hover>
                  <v-icon
                    v-on="on"
                    slot-scope="{ hover }"
                    v-on:click="toggleItemStatus(item, index)"
                    :color="`${hover ? 'gray' : 'primary'}`"
                    >check_circle
                  </v-icon>
                </v-hover>
              </template>
              <span>Maßnahme als nicht erledigt markieren</span>
            </v-tooltip>
          </template>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-text-field
          class="mr-5"
          v-model="item.label"
          :disabled="item.auto_managed === true"
          v-on:change="updateItem(item, index)"
          placeholder="Bezeichnung"
        >
        </v-text-field>
      </v-col>
      <v-col cols="7">
        <v-textarea
          rows="1"
          auto-grow
          v-model="item.description"
          :disabled="item.auto_managed === true"
          v-on:change="updateItem(item, index)"
          placeholder="Beschreibung"
        >
        </v-textarea>
      </v-col>
      <v-col cols="1">
        <v-row justify="center" v-if="item.auto_managed !== true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-icon
                  v-on="on"
                  slot-scope="{ hover }"
                  @click.stop="deleteItem(item, index)"
                  :color="`${hover ? 'error' : 'gray'}`"
                  >cancel
                </v-icon>
              </v-hover>
            </template>
            <span>Maßnahme löschen</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "SomeListItem",
  props: {
    item: Object,
    index: Number,
    oldItem: Object,
  },
  mounted() {
    this._oldItem = Object.assign({}, this.item);
  },
  methods: {
    toggleItemStatus(measure, index) {
      if (measure.status === "OPEN") {
        measure.status = "COMPLETED";
      } else {
        measure.status = "OPEN";
      }
      this.updateItem(measure, index);
    },
    updateItem(measure, index) {
      this.$emit("update-item", this._oldItem, measure, index);
      this._oldItem = Object.assign({}, this.item);
    },
    deleteItem(measure, index) {
      this.$emit("delete-item", measure, index);
    },
  },
  data: () => ({
    _oldItem: null,
  }),
};
</script>

<style scoped></style>
